import { render, staticRenderFns } from "./PresetVisualisation.vue?vue&type=template&id=383adc02&scoped=true"
import script from "./PresetVisualisation.vue?vue&type=script&setup=true&lang=ts"
export * from "./PresetVisualisation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PresetVisualisation.vue?vue&type=style&index=0&id=383adc02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383adc02",
  null
  
)

export default component.exports